import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Nav from './components/Nav';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import About from './pages/About';
import Photos from './pages/Photos';
import Music from './pages/Music';
import Merch from './pages/Merch';
import Shows from './pages/Shows';
import Video from './pages/Video';
import News from './pages/News';
import Epk from './pages/Epk';
import Privacy from './pages/Privacy';
import './App.css';

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="site-wrapper">
          <Nav />
          <main className="page-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/photos" element={<Photos />} />
              <Route path="/music" element={<Music />} />
              <Route path="/merch" element={<Merch />} />
              <Route path="/shows" element={<Shows />} />
              <Route path="/video" element={<Video />} />
              <Route path="/news" element={<News />} />
              <Route path="/epk" element={<Epk />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </HelmetProvider>
  );
}
